/**
 * Pannello di assegnazione delle commesse a un utente.
 *
 * È lo stesso meccanismo usato in Utenti e Accessi (tabella commesse_utenti):
 * l'assegnazione decide su quali commesse la persona può inviare SAL e
 * rendiconti. Qui è estratto in un componente per essere richiamato anche
 * dal pannello Consulenti.
 */
import { useEffect, useState } from 'react';
import { commesseApi, commesseUtentiApi } from '../api';

export default function AssegnaCommesse({ user }) {
  const [commesse, setCommesse] = useState([]);
  const [assegnate, setAssegnate] = useState([]);
  const [cerca, setCerca] = useState('');
  const [caricando, setCaricando] = useState(true);

  useEffect(() => {
    if (!user?.id) return;
    setCaricando(true);
    Promise.all([
      commesseApi.list({ stato: 'attiva' }),
      commesseUtentiApi.perUtente(user.id),
    ]).then(([cm, ass]) => { setCommesse(cm); setAssegnate(ass); })
      .catch(() => {})
      .finally(() => setCaricando(false));
  }, [user?.id]);

  const commuta = async (commessaId) => {
    try {
      if (assegnate.includes(commessaId)) {
        await commesseUtentiApi.remove(commessaId, user.id);
        setAssegnate(a => a.filter(x => x !== commessaId));
      } else {
        await commesseUtentiApi.add(commessaId, user.id);
        setAssegnate(a => [...a, commessaId]);
      }
    } catch (e) { alert(e); }
  };

  if (caricando) return <div className="text-sm text-gray-400 py-6 text-center">Caricamento…</div>;

  const q = cerca.trim().toLowerCase();
  // Le già assegnate restano sempre visibili, anche fuori dalla ricerca:
  // nasconderle farebbe sembrare persa un'assegnazione esistente.
  const filtrate = commesse.filter(c =>
    assegnate.includes(c.id) ||
    !q || `${c.numero} ${c.titolo} ${c.cliente_nome || ''}`.toLowerCase().includes(q));

  return (
    <div className="space-y-3">
      <input className="input py-1.5 text-sm" placeholder="Cerca numero, titolo o cliente…"
             value={cerca} onChange={e => setCerca(e.target.value)} />

      <div className="max-h-80 overflow-y-auto border rounded-lg divide-y">
        {commesse.length === 0 && <p className="text-gray-400 text-sm p-4 text-center">Nessuna commessa attiva</p>}
        {commesse.length > 0 && filtrate.length === 0 &&
          <p className="text-gray-400 text-sm p-4 text-center">Nessuna commessa corrisponde alla ricerca</p>}
        {filtrate.map(c => (
          <label key={c.id} className="flex items-center gap-3 px-3 py-2 hover:bg-gray-50 cursor-pointer">
            <input type="checkbox" className="w-4 h-4 shrink-0"
                   checked={assegnate.includes(c.id)} onChange={() => commuta(c.id)} />
            <span className="font-mono text-xs text-gray-500 shrink-0">{c.numero}</span>
            <span className="text-sm text-gray-800 truncate flex-1">{c.titolo}</span>
            <span className="text-xs text-gray-400 shrink-0">{c.cliente_nome || ''}</span>
          </label>
        ))}
      </div>

      <div className="text-xs text-gray-500">{assegnate.length} commesse assegnate</div>
    </div>
  );
}
